<header class="bg-white shadow">
  <div class="mx-auto py-6 px-4 sm:px-6 lg:px-8">
    <div class="lg:flex lg:items-center lg:justify-between">
      <div class="flex-1 min-w-0">
        <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate">
          Index Summary
        </h2>
        <p class="pt-1 px-0.5">Includes the past 30 days</p>
      </div>
    </div>
  </div>
</header>
<ng-container>
  <index-summary-table></index-summary-table>
</ng-container>